const hasSlider = document.querySelector('.js-webinars-slider__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation }]) => {
			const swiper = new Swiper('.js-webinars-slider__slider .swiper', {
				slidesPerView: 'auto',
				navigation: {
					prevEl: '.js-webinars-slider__slider-arrow-left',
					nextEl: '.js-webinars-slider__slider-arrow-right',
				},
				modules: [Navigation],
			});
		})
		.catch((err) => console.error(err));
}
